import { env } from '@cc-shopping/platform-env';
import type { BreadcrumbList, WithContext } from 'schema-dts';
import {
  BEST_CREDIT_CARDS_HUB,
  BREADCRUMB_PAGE_PREFIX_MAPPER,
  type BreadcrumbSource,
  CREDIT_CARDS_HUB,
  CREDIT_CARDS_REVIEWS_HUB,
} from '../constants';

const LEADING_SLASHES = /^\/+/;

type BreadcrumbListSchema = WithContext<BreadcrumbList>;

export function getBreadcrumbSchema({
  text,
  prefixPath,
  source,
  slug,
}: {
  text: string;
  prefixPath?: string;
  source: BreadcrumbSource;
  slug?: string;
}): BreadcrumbListSchema {
  const baseURL = env.NEXT_PUBLIC_NW_URL;

  const baseItemListElements: BreadcrumbList['itemListElement'] = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: baseURL,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Credit Cards',
      item: `${baseURL}${CREDIT_CARDS_HUB.link}`,
    },
  ];

  if (source === 'COMPARE' || (source === 'ROUNDUPS' && !slug)) {
    const canonicalUrl = `${baseURL}${prefixPath ? prefixPath.replace(LEADING_SLASHES, '') : BREADCRUMB_PAGE_PREFIX_MAPPER[source]}`;
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        ...baseItemListElements,
        {
          '@type': 'ListItem',
          position: 3,
          name: text,
          item: {
            '@id': canonicalUrl,
          },
        },
      ],
    };
  }

  if (source === 'REVIEWS') {
    const canonicalUrl = `${baseURL}${BREADCRUMB_PAGE_PREFIX_MAPPER[source]}${slug ? `/${slug}` : ''}`;
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        ...baseItemListElements,
        {
          '@type': 'ListItem',
          position: 3,
          name: CREDIT_CARDS_REVIEWS_HUB.title,
          item: `${baseURL}${CREDIT_CARDS_REVIEWS_HUB.link}`,
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: text,
          item: {
            '@id': canonicalUrl,
          },
        },
      ],
    };
  }

  if (source === 'ROUNDUPS') {
    const canonicalUrl = `${baseURL}${prefixPath ? prefixPath.replace(LEADING_SLASHES, '') : BREADCRUMB_PAGE_PREFIX_MAPPER[source]}${slug ? `/${slug}` : ''}`;
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        ...baseItemListElements,
        {
          '@type': 'ListItem',
          position: 3,
          name: BEST_CREDIT_CARDS_HUB.title,
          item: `${baseURL}${BEST_CREDIT_CARDS_HUB.link}`,
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: text,
          item: {
            '@id': canonicalUrl,
          },
        },
      ],
    };
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [...baseItemListElements],
  };
}
